import { Category } from "./../model/category";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { getImageUrl } from "../image";

@Component({
  selector: "category-card",
  templateUrl: "./category-card.component.html",
  styleUrls: ["./category-card.component.scss"]
})
export class CategoryCardComponent implements OnInit {
  @Input()
  public link: string = "#";

  @Input()
  public routerLink: string | any[];

  @Input()
  public category: Category;

  @Input()
  public newWindow?: boolean;

  @Input()
  public imageContain?: boolean;

  @Input()
  public loading = false;

  @Output()
  public resourceClick = new EventEmitter<Category>();

  constructor() {}

  ngOnInit() {}

  public onLinkClick(event: MouseEvent): void {
    if (
      !this.category?.resourceFilePath ||
      this.loading ||
      event.button > 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    this.resourceClick.emit(this.category);
  }

  getImage = getImageUrl;
}
